<template>
  <div>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-datos-personales
      block
      variant="relief-primary"
      class="btn-icon"
    >
      <feather-icon icon="EditIcon" />
      <!-- Editar -->
    </b-button>

    <b-modal
      id="modal-datos-personales"
      ok-title="guardar datos"
      ok-variant="relief-success"
      cancel-title="cancelar"
      cancel-variant="relief-danger"
      centered
      size="lg"
      title="Actualuizar Uniforme"
      @ok="validationForm"
    >
      <b-row>
        <b-col cols="12">
          <b-alert
            :show="status"
            variant="primary"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="AlertTriangleIcon"
              />
              <span class="ml-25">
                Por favor, verifica que los datos son correctos.
              </span>
            </div>
          </b-alert>
        </b-col>
        <b-col cosl="12">
          <validation-observer ref="formDatosPersonalesUpdate">
            <b-form>
              <b-row>
                <b-col cols="12">
                  <validation-provider
                    #default="{errors}"
                    name="Estado Civil"
                    rules="required"
                  >
                    <b-form-group label="Estado Civil">
                      <v-select
                        id="estado-civil"
                        v-model="newDP.estado_civil.id"
                        :options="catEstadoCivil"
                        :reduce="option => option.id"
                        placeholder="selecciona una opción"
                        value="value"
                        label="descripcion"
                      >
                        <template slot="no-options">
                          No hay datos para mostrar.
                        </template>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BAlert,
  BButton,
  BCol,
  BFormGroup,
  BForm,
  BModal,
  VBModal,
  BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import CatalogosService from '@/services/CatalogosService'
import PrebecarioService from '@/services/PrebecariosService'

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BAlert,
    BButton,
    BCol,
    BFormGroup,
    BForm,
    BModal,
    BRow,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    current: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      catEstadoCivil: [],
      newDP: null,
      status: false,
    }
  },
  mounted() {
    this.newDP = { ...this.current }
    this.fetchEstadoCivil()
  },
  methods: {
    msg({ title, text, icon }) {
      return this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    validationForm(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.formDatosPersonalesUpdate.validate().then(success => {
        if (success) {
          this.status = false
          this.saveDatosPersonales()
        } else {
          this.status = true
        }
      })
    },
    saveDatosPersonales() {
      PrebecarioService.updateDatosPersonales(this.id, {
        estado_civil_id: this.newDP.estado_civil.id,
      })
        .then(resp => {
          if (resp.status === 200) {
            this.$bvModal.hide('modal-datos-personales')
            const estadoCivil = this.catEstadoCivil.find(element => element.id === resp.data.estado_civil.id)
            this.$emit('update', { estadoCivil })
            this.msg({
              title: 'OK!',
              text: 'Datos actualizados correctamente!',
              icon: 'success',
            })
          }
        })
        .catch(() => {
          this.msg({
            title: 'Error!',
            text: 'Lo sentimos algo salio mal!',
            icon: 'error',
          })
        })
    },
    fetchEstadoCivil() {
      CatalogosService.getCatEstadoCivil()
        .then(resp => {
          this.catEstadoCivil = resp.data
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';

pre {
  min-height: 295px;
  padding: 1.5rem;
  margin-bottom: 0;
  border-radius: 0.5rem;
}
</style>
